export default "__VITE_ASSET__CWFMB0PY__"